export default __webpack_public_path__ + "static/media/office-365-logo.4f72fdac.png";